import { FC, useState } from "react";

import { useTranslator } from "@/i18n/useTranslator";

import { PhoneCallButton } from "../blocks";
import { RightPanel } from "../components/RightPanel";
import { DsButton, DsIcon } from "../components/ui";
import { useJobQuery } from "../data/queries/jobQueries";
import { JobServiceTaskBaseType } from "../domain/task";
import { DriverTaskDetails } from "./DriverTaskDetails";

const DriverTopActionButton: FC<JobServiceTaskBaseType> = ({
  jobId,
  serviceId,
  taskId,
}) => {
  const { t } = useTranslator();

  const { data: jobData } = useJobQuery({ jobId });

  const [isServiceDetailsDrawerOpened, setIsServiceDetailsDrawerOpened] =
    useState(false);

  const openServiceDetails = () => {
    setIsServiceDetailsDrawerOpened(true);
  };

  const onCloseServiceDetailsDrawer = () => {
    setIsServiceDetailsDrawerOpened(false);
  };

  const contactPhone = jobData?.site?.contact?.phone ?? "";
  const contactName = jobData?.site?.contact?.name ?? "";

  const serviceDetailsTitle = t("driver_top_action_button.service_details");

  return (
    <>
      <RightPanel
        title={serviceDetailsTitle}
        controlledOpen={isServiceDetailsDrawerOpened}
        content={
          <DriverTaskDetails
            jobId={jobId}
            serviceId={serviceId}
            taskId={taskId}
            isFromServiceDetailsDrawer
          />
        }
        backgroundColor="bg-gray-100"
        onDrawerClosed={onCloseServiceDetailsDrawer}
      />
      <div className="inline-flex gap-2">
        <PhoneCallButton
          phoneNumber={contactPhone?.toString() ?? ""}
          title={contactName}
        />

        <DsButton
          variant="white"
          className="w-full"
          onClick={openServiceDetails}>
          <DsIcon icon="RoundedExclamationMark" className="mr-2" />
          {serviceDetailsTitle}
        </DsButton>
      </div>
    </>
  );
};

export { DriverTopActionButton };
